import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';
import { Translate } from "@mui/icons-material";
import SvgComponent from "../assets/animated-background-squares_r";

function Main() {

    return (
        <div className="container" style={{ boxShadow: 'inset 0px -5px 10px rgba(0, 0, 0, 0.05)' }}>
            <div className="about-section">
                <div className="page-contents tablet" style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', flexDirection: 'row', gap: '5%' }}>
                    <div className="image-wrapper">
                        <img src={require('../assets/images/roclily-logo-v2.png')} alt="Logo" />
                    </div>
                    <div className="content">
                        {/* <div className="social_icons">
            <a href="https://github.com/yujisatojr" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/yujisato/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div> */}
                        <h1>RocLily&nbsp;<span style={{ fontWeight: 400 }}>Dev</span></h1>
                        {/* <p style={{ fontFamily: 'Source Code Pro', fontSize: 20, fontWeight: 500, transform: 'translate(7px, -35px)' }}>Code &bull; Build &bull; Grow</p> */}

                        {/* <div className="mobile_social_icons">
            <a href="https://github.com/yujisatojr" target="_blank" rel="noreferrer"><GitHubIcon/></a>
            <a href="https://www.linkedin.com/in/yujisato/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
          </div> */}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Main;